import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const settingsLocationChipDivStyle1 = css`
  display: flex;
  gap: ${theme.spacing(1)};
  align-items: center;
`;

const settingsLocationChipTextLinkStyle2 = css`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

export const SettingsLocationChipStyles = {
  settingsLocationChipDivStyle1,
  settingsLocationChipTextLinkStyle2,
};
